import axios from "../../utils/axios";

// A function to Fetch Posts from the server
export async function getPost(id) {
  const response = await axios.get(`/blogs/${id}`);
  return response.data;
}
